var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("Nested draggable")]),_vm._v(" "),_c('nested-draggable',{attrs:{"tasks":_vm.list}})],1),_vm._v(" "),_c('rawDisplayer',{staticClass:"col-3",attrs:{"value":_vm.list,"title":"List"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4c71618","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nested/nested-example.vue
// module id = null
// module chunks = 